import React from 'react';

import ProductSelection from "./ProductSelection"
import ScenarioSelection from "./ScenarioSelection"
import SoloView3D from "./SoloView3D"
import GalleryView from "./GalleryView"

export default function Sidebar({ roofProduct, roofColor, setRoofProduct, setRoofColor,
                                  facadeProduct, facadeColor, setFacadeProduct, setFacadeColor,
                                  productCategory, setProductCategory, scenario, setScenario,
                                  showImageGallery, setShowImageGallery, isSidebarVisible, setIsSidebarVisible, menuView, setMenuView}: any) {

  return (
    <div className={`full-sidebar-main-container`}>
      <div className={`sidebar-main-container ${isSidebarVisible ? '' : 'collapsed'} ${menuView !== "" ? 'reduced' : ''}`}>

        <div className="sidebar-title">
          <div className="sidebar-title-text">
            {menuView}
          </div>
          <div className={`sidebar-toggle ${isSidebarVisible ? '' : 'hidden'}`} onClick={() => setIsSidebarVisible(!isSidebarVisible)}>
            <i className={`fa-solid fa-xl ${isSidebarVisible ? 'fa-chevron-left' : 'fa-chevron-right'}`} style={{ color: `#fff` }} />
          </div>
        </div>

        {menuView === "PERSONALIZA" &&
          <div className="sidebar-config-container">
            <ScenarioSelection scenario={scenario} setScenario={setScenario}/>
            <ProductSelection roofProduct={roofProduct} setRoofProduct={setRoofProduct} roofColor={roofColor} setRoofColor={setRoofColor}
                              facadeProduct={facadeProduct} setFacadeProduct={setFacadeProduct} facadeColor={facadeColor} setFacadeColor={setFacadeColor}
                              scenario={scenario} setScenario={setScenario} productCategory={productCategory} setProductCategory={setProductCategory}
                              showImageGallery={showImageGallery} setShowImageGallery={setShowImageGallery} setMenuView={setMenuView}/>
          </div>
        }

        {menuView === "VISTA 3D" &&
          <div className={`sidebar-config-container`}>
            <SoloView3D product={productCategory === "roof" ? roofProduct : facadeProduct} color={productCategory === "roof" ? roofColor : facadeColor} setMenuView={setMenuView} showImageGallery={showImageGallery} setShowImageGallery={setShowImageGallery}/>
          </div>
        }

        {menuView === "GALERÍA" &&
          <div className={`sidebar-config-container`}>
            <GalleryView scenario={scenario} productCategory={productCategory} product={productCategory === "roof" ? roofProduct : facadeProduct} setProduct={productCategory === "roof" ? setRoofProduct : setFacadeProduct} setMenuView={setMenuView}/>
          </div>
        }

      </div>

    </div>
  );
}
